module.exports = __webpack_public_path__ + "img/arrow-desktop.47a243d7.png";